<template>
  <h2 :class="headingClass" @click="onHeadingClick">
    <span class="subtitle" v-if="!!subtitle">{{ subtitle }}</span>
    <span class="title">{{ title }}</span>
    <span class="icon">
      <template v-if="iconType === secIconType.text">
        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="17" height="20" rx="2" :fill="iconColor"/>
          <path d="M5 6H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 10H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 14H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </template>
      <template v-else-if="iconType === secIconType.movie">
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="22" height="16" rx="2" :fill="iconColor"/>
          <path d="M14.25 7.56699C14.5833 7.75944 14.5833 8.24056 14.25 8.43301L9.75 11.0311C9.41667 11.2235 9 10.983 9 10.5981L9 5.40192C9 5.01702 9.41667 4.77646 9.75 4.96891L14.25 7.56699Z" :fill="iconBgColor"/>
        </svg>
      </template>
    </span>
  </h2>
</template>

<script>
import { SEC_ICON_TYPE } from '@/CONSTS/MENUS'

export default {
  name: "SecHeading",
  data() {
    return {
      iconColor: '#FF7497',
      iconBgColor: 'white'
    }
  },
  props: {
    title: {
      type: String,
      default() {
        return ''
      }
    },
    subtitle: {
      type: String,
      default: ''
    },
    iconType: {
      type: Number,
      default() {
        return SEC_ICON_TYPE.text
      }
    },
    linkUrl: {
      type: String,
      default() {
        return ''
      }
    },
    disableHeader: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    secIconType() {
      return SEC_ICON_TYPE
    },
    headingClass(){
      let classArr = []

      if( this.iconType == null || this.iconType === SEC_ICON_TYPE.text ) {
        classArr.push('textlink')
      } else if ( this.iconType === SEC_ICON_TYPE.movie ) {
        classArr.push('movielink')
      }
      if( this.disableHeader ) {
        classArr.push('disable')
      }
      if( this.subtitle != null && this.subtitle.length > 0 ) {
        classArr.push('has-subtitle')
      }
      return classArr.join(' ')
    },
    sectype() {
      return MENU_SEC_TYPES
    }
  },
  methods: {
    onHeadingClick(){
      if(this.iconType === SEC_ICON_TYPE.movie) {
        this.$emit('head-click')
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

h2 {
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  background: url('/static/img/common/arrow_right.svg') no-repeat;
  background-size: auto 24px;
  background-position: right 16px top 22px;
  line-height: 1;

  position: relative;
  padding: 25px 20px 20px;
  margin: 0;

  .subtitle {
    display: inline-block;
    font-weight: bold;
    font-size: 11px;
    line-height: 1;
    position: absolute;
    color: $col_lite_font;
    top: 24px;
  }
  .title {
    width: 72%;
  }
  .icon {
    position: absolute;
    right: 40px;
    top: 24px;
    line-height: 1;
  }

  &::after {
    content: "";
    width: 15px;
    height: 2px;
    background: $col_def_gradient;
    position: absolute;
    bottom: 6px;
    left: 20px;
    display: block;

  }

  &.has-subtitle {
    padding-top: 44px;
    background-position: right 16px top 42px;
    .icon {
      top: 44px;
    }
  }
  &.textlink {
    .icon {
      width: 17px;
      height: 20px;
    }
  }
  &.movielink {
    cursor: pointer;
    pointer-events: auto;
    .icon {
      width: 22px;
      height: 16px;
      top: 26px;
    }
  }
  &.disable {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecHeading.vue